<template>
  <div class="main_center">
    <div class="content">
      <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
        <div class="search-drawer">
          <el-form :model="form" label-position="top" ref="form">
            <el-form-item label="关键字搜索：">
              <el-input clearable placeholder="请输入评价方/被评价方/项目名称" v-model="form.keywords"></el-input>
            </el-form-item>
            <el-form-item label="数据所属部门：">
            <select-depart-tree 
                ref="selectDepartTreeRef"
                :type="'2'"
                :modelValue.sync="form.superviseDeptCodeList"  
                :isMultiple="true" 
                @handleDeptType="(val)=>changeDept(val,'5')" >
                </select-depart-tree>
             </el-form-item>
          </el-form>
          <div class="search-drawer__footer">
            <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
            <el-button @click="refresh" plain size="small">重置</el-button>
          </div>
        </div>
      </searchBox>
      <div class="search-content">
       <div class="pageTitle">信用评价档案</div>
        <div class="searchBtn centerSearch">
          <!-- <span class="label-form">关键字搜索：</span> -->
          <el-input
            @keyup.enter.native="searchBtn"
            clearable
            placeholder="请输入评价方/被评价方/项目名称"
            style="width: 500px;"
            v-model="form.keywords"
          ></el-input>
          <el-button @click="searchBtn" class="rightSearchBtn" size="small" type="primary">搜索</el-button>
          <el-button
            @click="moreSearchItem = true"
            icon="el-icon-arrow-down"
            size="mini"
            type="text"
            class="height_four"
          >高级筛选</el-button>
        </div>
      </div>
    </div>
    <div class="tableContent_">
        <div class="mainBtn">
          <el-button
            @click="addNew()"
            size="small"
            type="primary"
            v-if="hasBtnPermission('credit_archives_add')"
          >
            <i class="el-icon-plus"></i>新增
          </el-button>
          <el-button
          @click="deleteSelectItem"
          size="small"
          v-if="hasBtnPermission('credit_archives_delete')"
        >删除</el-button>
        </div>
        <div class="searchBtn">
          <!-- <span class="label-form">关键字搜索：</span>
          <el-input
            @keyup.enter.native="searchBtn"
            clearable
            placeholder="请输入评价方/被评价方/项目名称"
            style="width: 500px"
            v-model="form.keywords"
          ></el-input>  -->
          <!-- <el-button
            size="small"
            @click="searchBtn"
            slot="append"
            icon="el-icon-search"
            type="primary"
          ></el-button>-->
          <!-- <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
          <el-button
            @click="moreSearchItem = true"
            icon="el-icon-arrow-down"
            size="mini"
            type="text"
          >高级筛选</el-button> -->
        </div>
    
      <el-table
        :header-cell-style="this.$globalGrayTableHeaderStyle"
        :height="tableMaxHeight"
        :data="tableData"
        border
        class="table-content"
        ref="multipleTable"
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        @filter-change="filterChange"
        v-loading="dataListLoading"
        @select-all="selectAll"
      >
        <el-table-column
          align="left"
          fixed
          type="selection"
          :selectable="checkSelectable"
          v-if="hasBtnPermission('credit_archives_delete')"
        ></el-table-column>
        <el-table-column
          :index="indexMethod"
          :show-overflow-tooltip="true"
          align="center"
          fixed
          label="序号"
          type="index"
          width="50"
        ></el-table-column>  
        <!-- :filters="statusFilters" -->
        <el-table-column
          
          align="center"
          fixed
          label="评价状态"
          prop="status"
          width="100"
        >
          <template slot-scope="scope">
            <i :class="formatterStatusClass(scope.row.status)"></i>
            <span>{{ formatterStatusText(scope.row.status) }}</span>
          </template>
        </el-table-column>       
     
        <el-table-column
        :filters="subjectTypeFilters"
          :show-overflow-tooltip="true"
          align="left"
          fixed
          label="评价触发业务节点"
          prop="datasetCodeName"
          width="185"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          fixed
          label="评价方名称"
          min-width="180"
          prop="evaluatorName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          header-align="center"
          label="评价方角色"
          min-width="180"
          prop="evaluatorRoleTypeName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="被评价方名称"
          min-width="180"
          prop="toEvaluatorName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="被评价方角色"
          min-width="180"
          prop="toEvaluatorRoleTypeName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="评价结果"
          min-width="180"
          prop="matchValue"
        >
          <template scope="scope">
            <!-- 滑块 -->
            <span
              v-if="scope.row.evaluateConfigType===1"
            >{{ scope.row.matchValue? scope.row.matchValue: '--' }}分</span>
            <!-- 星星 -->
            <span v-else-if="scope.row.evaluateConfigType===2 && scope.row.iconType===2">
              <el-rate
                v-model="scope.row.matchValue"
                :max="scope.row.level===1?2:(scope.row.level===2?3:5)"
                disabled
              ></el-rate>
            </span>
            <!-- 自定义 -->
            <span v-else-if="scope.row.evaluateConfigType===2 &&scope.row.iconType===1">
              <!-- {{ scope.row.name? scope.row.name: '--' }} -->
              <img
                v-if="scope.row.matchValue"
                :src="scope.row.matchValue"
                alt
                width="22px"
                height="22px"
              />
            </span>
            <span v-else>-----</span>
          </template>
        </el-table-column>

<!-- :sortable="true" -->
        <el-table-column
          :show-overflow-tooltip="true"  
          align="center"
          header-align="center"
          label="评价发出时间"
          sortable
          min-width="160"
          prop="sendTime"
        >
          <template scope="scope">
            <span>{{ scope.row.sendTime ? formatDate(scope.row.sendTime, "yyyy-MM-dd") : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          :sortable="true"
          align="center"
          header-align="center"
          label="评价提交时间"
          min-width="160"
          prop="submitTime"
        >
          <template scope="scope">
            <span>{{ scope.row.submitTime ? formatDate(scope.row.submitTime, "yyyy-MM-dd") : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="评价描述"
          width="200"
          prop="describeContent"
        >
          <template scope="scope">
            <span>{{ scope.row.describeContent ? scope.row.describeContent : '--' }}</span>
          </template>
        </el-table-column>

        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="关联项目"
          width="140"
        >
          <template scope="scope">
            <!-- graininess 1：招标项目，2：标段 -->
            <span>{{ scope.row.graininess ===1 ? scope.row.tenderProjectName : scope.row.bidSectionName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="修改人"
          min-width="140"
          prop="updateUser"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          :sortable="true"
          align="center"
          header-align="center"
          label="修改时间"
          min-width="155"
          prop="updateTime"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="创建人"
          min-width="140"
          prop="createUser"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          sortable
          align="center"
          header-align="center"
          label="创建时间"
          min-width="155"
          prop="createTime"
        ></el-table-column>
        <el-table-column align="left" header-align="center" fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <!-- scope.row.canModify && -->
            <el-button
              @click="routerDetail(scope.row, (scope.row.status == 1 ? 'edit' : 'view'))"
              type="text"
              v-if="hasBtnPermission('credit_archives_view')"             
            >查看</el-button>
            <el-divider direction="vertical" v-if="scope.row.status === 1&&scope.row.type===1&&hasBtnPermission('credit_archives_delete')"></el-divider>
            <el-button
              @click="routerDetail(scope.row, 'modify')"
              type="text"
              v-if="scope.row.status == 2&&getEndtime(scope.row) && hasBtnPermission('credit_archives_change')"
            >修改</el-button>
            <el-divider direction="vertical" v-if="scope.row.status == 2"></el-divider>
            <el-button
              @click="showRevokeForm(scope.row)"
              type="text"
              v-if="scope.row.status == 2&&getEndtime(scope.row) && hasBtnPermission('credit_archives_revoke')"
            >撤回</el-button>
            <el-divider direction="vertical" v-if="scope.row.status == 2"></el-divider>
            <el-button @click="deleteById(scope.row)" type="text" v-if="scope.row.status === 1&&scope.row.type===1&&hasBtnPermission('credit_archives_delete')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[pageSize, 20, 50, 100]"
        :total="total"
        @current-change="currentChangeHandle"
        @size-change="sizeChangeHandle"
        background
        layout="total, sizes, prev, pager, next"
        style="padding-bottom:12px;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  evaluateArchiveList,
  evaluateArchiveDelete,
  getWithdraw
} from "@/server/mainCredit.js";
import selectDepartTree from "@/views/modules/components/selectDepartTree"
import { mapState } from "vuex";
export default {
  name: "busWitnessTable",
  components: {selectDepartTree},
  data() {
    return {
      value1rate: 4,
      tableMaxHeight: document.documentElement.clientHeight - 363,
      dataListLoading: false,
      businessTypeNamelist: [],
      witnessStatuslist: [],
      form: {
        keywords: "",
        flowName: "",
        superviseDeptCodeList:[]
      },
      statusFilters: [],
      subjectTypeFilters: [],
      punishTypeFilters: [],
      scopeTypeFilters: [],
      datasetCodeNameFilter: [],
      filters: {},
      sortParams: {
        order: "desc",
        prop: "sendTime"
      },
      moreSearchItem: false,
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      total: 0, //总条数
      tableData: [],
      multipleSelection: []
    };
  },
  props: {
    
  },
  filters: {},
  computed: {
    ...mapState({
      // 业务节点
      evalBusinessTypeList: state => state.dataDictionary.evalBusinessTypeList,
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
    })
  },
  watch: {
    evalBusinessTypeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.evalBusinessTypeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "datasetCode_" + item.value
            });
          });
          this.subjectTypeFilters = filters;
        });
      }
    },
    uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){
            this.getDataList();
          }
        }
    }
  },
  created() {
    this.$store.dispatch("dataDictionary/getEvalBusinessTypeList"); //获取评价触发类型
    this.getStatusList();
  },
  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
    that.ifmove();
    this.getDataList();
  },
  methods: {
    changeDept(val,str){//切换部门
    this.form.superviseDeptCodeList=[]
            if(str==='5'){
            // 多选
                val.forEach((item,index)=>{
                if( item.type!=="region"){
                    this.form.superviseDeptCodeList.push(item.code)
                }
            })
            }
        },
    getEndtime(row){
       if(row.endTime){
        let timestamp=new Date().getTime();
        let endDate= row.endTime.replace(new RegExp("-","gm"),"/");
        let end = (new Date(endDate)).getTime(); //得到毫秒数
        let result=end-timestamp
        return result>0;

       }else{
         return true;
       }
    },
    // 判断表格行是否可选
    checkSelectable(row, index) {
      /**
       * row：当前行数据
       * index：当前第几位
       */
      let flag = true;
      //  row.canModify  需求没写是否控制
      if (
        row.status == 1 &&
        this.hasBtnPermission("credit_archives_delete")
      ) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    selectAll(selection) {
      if (selection.length==0) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id);
      });

      if (ids != "" || ids.length > 0) {
        this.$confirm(
          `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          evaluateArchiveDelete({
            idList: ids
          }).then(res => {
            if (res.data.code == "1") {
              this.$message({
                type: "success",
                message: "数据删除成功！"
              });
              this.getDataList();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          });
        });
      } else {
        this.$message({
          type: "error",
          message: "未选择删除项。"
        });
      }
    },
    computeBtnLenth(item) {
      if (this.hasBtnPermission("main_credit_exposal_commit")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_add")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_delete")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_revoke")) {
        item.btnLength = 1;
      } else {
        item.btnLength = 0;
      }

      return item.btnLength;
    },
    dialogCancle() {
      this.moreSearchItem = false;
    },
    ifmove() {
      let tableMaxHeight = document.documentElement.clientHeight - 363;
      this.pageSize = parseInt(tableMaxHeight / 57) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
      // this.getDataList()
    },

    formatterStatusClass(historyId) {
      switch (historyId) {
        case 1:
          return "icon-point icon-point-verificationing";
          break;
        case 2:
          return "icon-point icon-point-success";
          break;
        case 3:
          return "icon-point icon-point-info";
          break;
          case 4:
          return "icon-point icon-point-info";
          break;
        default:
          return "";
          break;
      }
    },
    formatterStatusText(num) {
      switch (num) {
        case 1:
          return "待提交";
          break;
        case 2:
          return "已提交";
          break;
        case 3:
          return "已撤回";
          break;
        case 4:
          return "已截止";
          break;
        default:
          return "";
          break;
      }
    },
    getStatusList() {
      this.statusFilters = [
        { text: "待提交", value: "status_1" },
        { text: "已提交", value: "status_2" },
        { text: "已撤回", value: "status_3"},
        { text: "已截止", value: "status_4" }
      ];
    },
    addNew() {
      removeTabHandle("credit_archives_detail");
      this.$router.push({
        name: "credit_archives_detail",
        query: {
          type: 1
        }
      });
    },

    getDataList() {
      // 获取列表数据
      this.dataListLoading = true;
      this.filters.superviseDeptCodeList= (this.form.superviseDeptCodeList || []).length==0?this.uerdefultOptionCode:this.form.superviseDeptCodeList
      evaluateArchiveList({
        page: this.pageIndex,
        rows: this.pageSize,
        searchKey: this.form.keywords,       
        orderBy:
          this.sortParams.prop && this.sortParams.order
            ? this.sortParams.prop +
              (this.sortParams.order == "ascending" ? " asc" : " desc")
            : "",
         filter: this.filters
      }).then(res => {
        this.tableData = res.data.rows;
        // 假数据
        this.tableData.forEach(item => {
          if (item.evaluateConfigType === 2 && item.iconType === 1) {
          } else {
            item.matchValue = item.matchValue * 1;
          }
          item.btnLength = this.computeBtnLenth(item);
        });
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading = false;
      });
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    filterChange(filters) {
      let filtersParams = {};
      for (var i in filters) {
        var filtersArr = filters[i];
        let key = "",
          value = [];
        filtersArr.length > 0 &&
          filtersArr.forEach(item => {
            key = item.split("_")[0];
            value.push(item.split("_")[1]);
          });
        key && value.length > 0
          ? (filtersParams[key] = value.toString())
          : null;
      }
      // console.log(filtersParams,"filtersParams");
      this.filters = filtersParams;
      this.getDataList();
    },
    sortChange(column, prop, order) {
      console.log(column, prop, order,"column, prop, order");
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getDataList();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //搜索按钮
    searchBtn() {
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.filters.tradeId=this.form.tradeId
      this.getDataList();
    },

    refresh() {
      //刷新按钮
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.form.keywords = "";
      this.form.superviseDeptCodeList=[]
       // 重置默认所属数据
       if( this.$refs.selectDepartTreeRef){
        this.$refs.selectDepartTreeRef.getUserTreeOption()
        }
      this.getDataList();
    },

    routerDetail(item, flag) {
      // 跳转详情
      if (flag == "view") {
        removeTabHandle("credit_archives_view");
        this.$router.push({
          name: "credit_archives_view",
          query: {
            id: item.id,
            type: item.type
          }
        });
      }
      // 编辑 修改页面
      if (flag == "edit" || flag == "modify") {
        removeTabHandle("credit_punish_detail");
        this.$router.push({
          name: "credit_archives_detail",
          query: {
            id: item.id,
            type: item.type,
            modify: flag == "modify" ? true : false
          }
        });
      }
    },
    showRevokeForm(data) {
      this.$confirm(`确定撤回吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        getWithdraw({ id: data.id })
          .then(res => {
            if (res) {
              this.$message.success("数据撤回成功！");
              this.getDataList();
            }
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    deleteById(item) {
      this.$confirm(
        `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        evaluateArchiveDelete({
          id: item.id
        }).then(res => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "数据删除成功！"
            });
            this.getDataList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      });
    },

    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id);
      });
      if (ids != "" || ids.length > 0) {
        this.$confirm(
          `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          evaluateArchiveDelete({
            idList: ids
          }).then(res => {
            if (res.data.code == "1") {
              this.$message({
                type: "success",
                message: "数据删除成功！"
              });
              this.getDataList();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          });
        });
      } else {
        this.$message({
          type: "error",
          message: "未选择删除项。"
        });
      }
    }
  },

  destroyed() {
    window.onresize = null;
  }
};
</script>
<style lang="scss">
.content{
    .centerSearch{
        .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .rightSearchBtn{
        height:40px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .height_four{
        height: 40px;
    }
     .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }
}
</style>

<style lang="scss" scoped>
.main_center {
  .search-content {
    padding:24px;
    display: flex;
    align-items: center;
    .searchBtn {
    width:calc(100% - 140px);
    height: 40px;
    float: none;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    }
    .pageTitle{
        font-size: 18px;
        font-weight: 600;
        color: #000000; 
        height: 40px; 
        margin-top:-9px;
    }
  }
  .search-content > div{
     line-height: normal;
     padding: 0;
  }
  .mainBtn{
    padding:15px;
  }
}
.btnBox {
  display: flex;
  flex-direction: column;

  .el-button {
    margin-left: 0px;
    margin-top: 10px;
  }
}
</style>
